import React from 'react';
import { motion } from 'framer-motion';
export function PackImage() {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const books = [{
    src: 'https://cdn.magicpatterns.com/uploads/uzVcmMiLu1ipfH9uEDEbht/bono_4.png',
    alt: 'Tabla de Conversiones y Trucos de Repostería',
    rotate: -8,
    z: 10,
    delay: 0.4,
    label: 'BONO'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/g9AaoEg2otWtRz43zT2yt6/bono_1.png',
    alt: 'Recetario Especial de Budines Salados',
    rotate: -4,
    z: 20,
    delay: 0.2,
    label: 'BONO'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/nawWvpqHPEcVQZh4mEzqsy/0_Cover_1.png',
    alt: 'Coberturas y Glaseados Perfectos - Producto Principal',
    rotate: 0,
    z: 30,
    delay: 0,
    label: 'PRINCIPAL',
    isMain: true
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/8ypHRLb9VEDK6jfR25tRfv/bono_2.png',
    alt: 'Guía de Coberturas y Glaseados para Budines',
    rotate: 4,
    z: 20,
    delay: 0.3,
    label: 'BONO'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/96MkCzRENFR6zfrQegjT5j/bono_3.png',
    alt: 'Kit para Empezar a Vender Budines Caseros',
    rotate: 8,
    z: 10,
    delay: 0.5,
    label: 'BONO'
  }];
  return <section className="py-20 bg-[#FFF8F0] text-[#3D2B1F] px-4 overflow-hidden" data-id="element-109">
      <div className="max-w-6xl mx-auto text-center" data-id="element-110">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-black mb-4 text-[#C67B30]" data-id="element-111">
          Todo esto es tuyo hoy
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-[#9C8578] mb-14 font-medium" data-id="element-112">
          1 libro principal + 4 bonos exclusivos
        </motion.p>

        {/* Pack display - ordered horizontal shelf */}
        <div className="relative cursor-pointer group max-w-4xl mx-auto" onClick={scrollToOffer} data-id="element-113">
          {/* Subtle glow behind */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[60%] bg-[#C67B30]/8 rounded-full blur-[80px] group-hover:bg-[#C67B30]/12 transition-colors duration-500 pointer-events-none" data-id="element-114"></div>

          {/* Books row */}
          <div className="flex items-end justify-center -space-x-6 md:-space-x-10 relative" data-id="element-115">
            {books.map((book, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: book.delay
          }} className="relative flex-shrink-0" style={{
            zIndex: book.z
          }} data-id="element-116">
                <div className={`relative transition-all duration-500 ${book.isMain ? 'group-hover:scale-105 group-hover:-translate-y-3' : 'group-hover:scale-[1.02]'}`} style={{
              transform: `rotate(${book.rotate}deg)`
            }} data-id="element-117">
                  <img src={book.src} alt={book.alt} className={`object-contain drop-shadow-[0_10px_30px_rgba(61,43,31,0.2)] rounded-lg ${book.isMain ? 'w-[140px] md:w-[220px] lg:w-[260px] drop-shadow-[0_15px_40px_rgba(61,43,31,0.3)]' : 'w-[100px] md:w-[160px] lg:w-[200px]'}`} data-id="element-118" />
                  {/* Label badge */}
                  {book.isMain ? <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#C67B30] text-white text-[10px] md:text-xs font-black px-3 py-1 rounded-full shadow-md uppercase tracking-wider whitespace-nowrap" data-id="element-119">
                      ⭐ Libro Principal
                    </div> : <div className="absolute -top-2 left-1/2 -translate-x-1/2 bg-red-500 text-white text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-full shadow-sm uppercase tracking-wider whitespace-nowrap" data-id="element-120">
                      🎁 Gratis
                    </div>}
                </div>
              </motion.div>)}
          </div>

          {/* Value badge below */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6
        }} className="mt-10 inline-flex items-center gap-3 bg-white border border-[#C67B30]/20 rounded-full px-6 py-3 shadow-lg" data-id="element-121">
            <span className="text-[#9C8578] line-through text-lg font-bold" data-id="element-122">
              $39.990 ARS
            </span>
            <span className="w-px h-6 bg-[#3D2B1F]/10" data-id="element-123"></span>
            <span className="text-[#C67B30] text-2xl font-black" data-id="element-124">
              $19.990 ARS
            </span>
            <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full animate-pulse" data-id="element-125">
              -50%
            </span>
          </motion.div>
        </div>
      </div>
    </section>;
}